import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import AdCard from '../components/AdCard';
import { API_ENDPOINTS } from '../config/api';
import BackToHome from '../components/BackToHome';

const CategoryPage = () => {
  const { categoryId } = useParams();
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAds = async () => {
      setLoading(true);
      try {
        const response = await axios.get(API_ENDPOINTS.ADS.GET_ALL, { params: { category: categoryId } });
        setAds(response.data || []);
      } catch (err) {
        setAds([]);
      }
      setLoading(false);
    };
    fetchAds();
  }, [categoryId]);

  return (
    <div style={{ padding: '20px' }}>
      <BackToHome />
      <h1 style={{ textAlign: 'center' }}>{categoryId.charAt(0).toUpperCase() + categoryId.slice(1)}</h1>
      {loading ? (
        <p>Loading...</p>
      ) : ads.length === 0 ? (
        <p style={{ textAlign: 'center' }}>No ads found for this category.</p>
      ) : (
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
          {ads.map(ad => (
            <AdCard key={ad._id} ad={ad} />
          ))}
        </div>
      )}
    </div>
  );
};

export default CategoryPage; 